import { render } from "./CreateCommunication.vue?vue&type=template&id=71a20520&scoped=true"
import script from "./CreateCommunication.vue?vue&type=script&lang=js"
export * from "./CreateCommunication.vue?vue&type=script&lang=js"

import "./CreateCommunication.vue?vue&type=style&index=0&id=71a20520&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a20520"]])

export default __exports__